import React from 'react';
import { Container, Button } from 'reactstrap';
import guardIdentity from '../../guard_identity.svg';
import breachScan from '../../breach_scan.svg';
import addVirtualEmail from '../../add_virtual_email.svg';
import { paths } from '../../constants';
import { NavLink as RRNavLink } from 'react-router-dom';
import Jumbotron from '../../components/Jumbotron/Jumbotron';
import './Home.css';

const Home = () => {
  const features = [
    {
      id: 1,
      title: 'Guard Your Identity',
      description: 'Mask your online presence by hiding your primary email address from websites and services.',
      image: guardIdentity,
    },
    {
      id: 2,
      title: 'Disposable Emails',
      description: 'Create disposable email addresses for signing up on other websites without exposing your real email.',
      image: addVirtualEmail,
    },
    {
      id: 3,
      title: 'Breach Monitoring',
      description: 'Automated scanning of public breach databases to alert you if your information is compromised.',
      image: breachScan,
      badge: 'Premium',
    }
  ];

  return (
    <div className="home-page">
      <Container>
        <Jumbotron>
          <h1 className="display-5">Protect Your Online Self</h1>
          <p className="lead">
            ID Unseen provides powerful tools to help improve your security and privacy while online.
          </p>
          <Button color="primary" size="lg" tag={RRNavLink} to={paths.register}>
            Get Started Free
          </Button>
        </Jumbotron>

        <section className="features-section">
          <h2 className="section-title">Why Choose ID Unseen?</h2>
          <div className="features-grid">
            {features.map((feature) => (
              <div key={feature.id} className="feature-card">
                <div className="feature-icon">
                  <img src={feature.image} alt={feature.title} />
                </div>
                <div className="feature-content">
                  <h3 className="feature-title">
                    {feature.title}
                    {feature.badge && <span className="feature-badge">{feature.badge}</span>}
                  </h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="cta-section">
          <div className="cta-content">
            <h2>Ready to take control of your privacy?</h2>
            <p>Join thousands of users who trust ID Unseen to protect their online identity.</p>
            <Button color="primary" size="lg" tag={RRNavLink} to={paths.register}>
              Create Free Account
            </Button>
          </div>
        </section>
      </Container>
    </div>
  );
};

export default Home;
